<div class="container-fluid p-0 landing-page">
  <section class="hero-section" appDetectInView (scrolledIntoView)="heroScrolledInView()" (scrolledOutOfView)="heroScrolledOutOfView()">
    <div class="hero-bg" #heroBG>
      <img src="assets/images/hero-bg.svg" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="content-card">
            <h1 class="hero-title">
              Pursue your career in Machine Learning & AI with our <span class="highlighted">Bootcamp</span>
            </h1>
            <div class="hero-pills">
              <div class="pill">Part time</div>
              <div class="pill">Live virtual classes</div>
              <div class="pill">1-to-1 support sessions</div>
            </div>
          </div>
          <div class="hero-buttons">
            <button class="btn btn-primary">
              <span class="btn-label">Register Now</span>
            </button>
            <button class="btn btn-secondary">
              <span class="btn-label">Download Syllabus</span>
            </button>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="video-container">
            <div class="video-card">
              <div class="video-placeholder-card" [ngClass]="{'d-none': isVideoOpen}">
                <button class="btn video-btn" (click)="onStartHeroVideo()">
                  <img src="assets/images/play.svg" alt="Play">
                </button>
              </div>
              <div class="video">
                <video [controls]="isVideoOpen" preload="metadata" #heroVideo>
                  Video is not supported
                  <source src="assets/videos/placeholder-video.mp4">
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="cta-section">
    <div class="container">
      <h2 class="cta-title" appFadeIntoView>
        <span class="line">
          Whether you are <span class="highlighted">switching your career</span> or <span class="highlighted">levelling up your skills </span>
        </span>
        <span class="line">You've come to the right place!</span>
      </h2>
      <div class="pills">
        <div class="pill" appFadeIntoView>
          <img src="assets/images/check-circle-green.svg" alt="">
          <span class="text">No technical background is required</span>
        </div>
        <div class="pill" appFadeIntoView>
          <img src="assets/images/check-circle-green.svg" alt="">
          <span class="text">Career support services</span>
        </div>
      </div>
    </div>
  </section>
  <section class="didyouknow-section">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-12">
          <div class="img-container" appFadeIntoView>
            <img src="assets/images/did-you-know-image.png" alt="">
          </div>
        </div>
        <div class="col-md-6 col-12">
          <h3 class="title" appFadeIntoView>Did you know?</h3>
          <p class="subtitle" appFadeIntoView>According to Payscale in 2022</p>
          <div class="stat-cards">
            <div class="stat-card" appFadeIntoView>
              <div class="icon">
                <img src="assets/images/dollar-icon.svg" alt="">
              </div>
              <div class="details">
                <p class="number">$87K</p>
                <p class="text">Average salary for <span class="bold">entry level jobs in Canada</span></p>
              </div>
            </div>
            <div class="stat-card" appFadeIntoView>
              <div class="icon">
                <img src="assets/images/chart-arrow-icon.svg" alt="">
              </div>
              <div class="details">
                <p class="number">75%</p>
                <p class="text">Increased job demand over the past <span class="bold">4 years</span></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="plans-section">
    <div class="container">
      <img src="assets/images/plans-bg.svg" alt="" class="plans-bg bg-top">
      <img src="assets/images/plans-bg.svg" alt="" class="plans-bg bg-bottom">
      <h2 class="title" appFadeIntoView>
        <span class="highlighted">Flexible</span> Payment Plans That Work For You
      </h2>
      <p class="subtitle" appFadeIntoView>
        We consider our bootcamp to be an investment, and we want to make it as easy as possible for you
      </p>
      <div class="plans row">
        <div class="col-lg-6 col-12">
          <div class="plan-card" appFadeIntoView>
            <div class="img-container">
              <img src="assets/images/upfront-payment.svg" alt="">
            </div>
            <h3 class="plan-name">Upfront Payment</h3>
            <div class="plan-price">
              <span class="currency">CA$</span>
              <span class="price">8,995</span>
            </div>
            <div class="plan-features">
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">Pay all fees at once</p>
              </div>
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">No additional fees required</p>
              </div>
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">
                  <span class="bold">100%</span> tuition fees <span class="bold">refund</span> upon withdrawal on the first week
                </p>
              </div>
            </div>
            <button type="button" class="btn btn-primary plan-btn">
              <span class="btn-label">Register Now</span>
              <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="plan-card" appFadeIntoView>
            <div class="img-container">
              <img src="assets/images/monthly-payment.svg" alt="">
            </div>
            <h3 class="plan-name">Monthly Installments</h3>
            <div class="plan-price">
              <span class="currency">CA$</span>
              <span class="price">8,995</span>
              <span class="price price-addition"> + GST</span>
            </div>
            <div class="plan-features">
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text"><span class="bold">20% upfront</span> and monthly payments afterward.</p>
              </div>
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">Split payment over <span class="bold">6 Months</span></p>
              </div>
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">CA$ <span class="bold">253</span> Adminstiration fees</p>
              </div>
              <div class="plan-feature">
                <div class="icon">
                  <img src="assets/images/check-circle-green.svg" alt="">
                </div>
                <p class="text">
                  <span class="bold">100%</span> tuition fees <span class="bold">refund</span> upon withdrawal on the first week</p>
              </div>
            </div>
            <button type="button" class="btn btn-primary plan-btn">
              <span class="btn-label">Register Now</span>
              <i class="pi pi-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="partnership-section" appDetectInView (scrolledIntoView)="partnershipScrolledInView()" (scrolledOutOfView)="partnershipScrolledOutOfView()">
    <div class="container">
      <img src="assets/images/cylinder-wide.svg" alt="" class="partnership-section-bg" #partnershipSectionBG>
      <div class="row">
        <div class="col-12">
          <div class="logo-white" appFadeIntoView>
            <img src="assets/images/ubc-logo-white.svg" alt="">
          </div>
          <p class="text" appFadeIntoView>
            <span class="title d-block" #partnershipSectionTitle>
              In partnership with <span class="highlighted">The University of British Columbia Extened Learning</span>
            </span>
          </p>
          <div class="partnership-cards-container">
            <div class="partnership-card" appFadeIntoView>
              <div class="bg-shadow"></div>
              <div class="icon">
                <img src="assets/images/gamepad-icon-border.svg" alt="">
              </div>
              <div class="details">
                <p class="title">Interactive</p>
                <p class="subtitle">An interactive  experience with RoboGarden’s game-based platform</p>
              </div>
            </div>
            <div class="partnership-card" appFadeIntoView>
              <div class="bg-shadow"></div>
              <div class="icon">
                <img src="assets/images/check-blue-icon-border.svg" alt="">
              </div>
              <div class="details">
                <p class="title">Real-World Challenges</p>
                <p class="subtitle">Development environment where you can access and solve real-world challenges</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="parttime-section">
    <img src="assets/images/parttime-dots-bg.svg" alt="" class="section-bg bg-top">
    <img src="assets/images/parttime-lines-bg.svg" alt="" class="section-bg bg-bottom">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="title" appFadeIntoView>Part-time <span class="highlighted">Online</span> bootcamp</h3>
          <p class="subtitle" appFadeIntoView>
            Balance your daily commitments while pursuing your career in machine learning & AI with our <span class="bold">part-time</span> bootcamp
          </p>
        </div>
        <div class="col-md-4 col-12">
          <div class="parttime-card" appFadeIntoView>
            <div class="card-shadow"></div>
            <div class="text-wrapper">
              <span class="stat-number">6</span>
              <span class="stat-label">Months</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="parttime-card" appFadeIntoView>
            <div class="card-shadow"></div>
            <div class="text-wrapper">
              <span class="stat-number">22</span>
              <span class="stat-label">Weeks</span>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-12">
          <div class="parttime-card" appFadeIntoView>
            <div class="card-shadow"></div>
            <div class="text-wrapper">
              <span class="stat-number">450</span>
              <span class="stat-label">Hours</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="live-support-section">
    <img src="assets/images/live-support-net.svg" alt="" class="live-support-net">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-8 col-12 live-support-img">
          <div class="img-container" appFadeIntoView>
            <img src="assets/images/live-support-img.png" alt="">
          </div>
        </div>
        <div class="col-lg-6 col-md-4 col-12">
          <div class="details">
            <h2 class="title" appFadeIntoView>
              One-to-one Live Support Sessions
            </h2>
            <p class="subtitle" appFadeIntoView>
              The bootcamp’s teaching assistant is dedicated to supporting you throughout your educational journey. You will be able
              to reach out your teaching assistant to get online service outside of live session time.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="you-will-section you-will-learn-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="section-title" appFadeIntoView>You Will Learn</h3>
        </div>
        <div class="col-12 content-wrapper">
          <div class="content-label" appFadeIntoView>
            <span>16 Learning Weeks</span>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 text-wrapper">
              <p class="title" appFadeIntoView>Basic Programming Concepts</p>
              <div class="list">
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Develop awareness and master basic programming concepts to solve real problems.</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 img-wrapper" appFadeIntoView>
              <div class="img-bg basic"></div>
              <div class="img-container justify-content-end">
                <img src="assets/images/basic-prog-concepts-img.svg" alt="">
              </div>
            </div>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 img-wrapper order-md-0 order-1" appFadeIntoView>
              <div class="img-bg data"></div>
              <div class="img-container justify-content-start">
                <img src="assets/images/data-handling-img.svg" alt="">
              </div>
            </div>
            <div class="col-md-6 col-12 text-wrapper order-md-1 order-0">
              <p class="title" appFadeIntoView>Data Handling & Visualization</p>
              <div class="list">
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Master data handling, processing, and visualization.</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Analyze data classification, Examine and implement data regression.</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Understand and demonstrate data clustering.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 text-wrapper">
              <p class="title" appFadeIntoView>Real-World Applications</p>
              <div class="list">
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Apply software methodology to create applications.</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Identify the real-world application in which machine learning makes a difference in our lives.</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Identify the state of the art related to all topics of machine learning.</span>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 img-wrapper" appFadeIntoView>
              <div class="img-bg real"></div>
              <div class="img-container justify-content-end">
                <img src="assets/images/real-world-img.svg" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="you-will-section you-will-build-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="section-title" appFadeIntoView>You Will Build</h3>
        </div>
        <div class="col-12 content-wrapper">
          <div class="content-label" appFadeIntoView>
            <span>4 Capstone Project Weeks</span>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 text-wrapper order-md-0 order-1">
              <p class="title" appFadeIntoView>Capstone Project</p>
              <p class="desc" appFadeIntoView>
                You will build Freelance-style capstone projects at the end of the Bootcamp. The list of projects reflects real-world
                industry demand, while the freelancing bid process builds your confidence to navigate independent contract work
                successfully.
              </p>
            </div>
            <div class="col-md-6 col-12 img-wrapper order-md-1 order-0" appFadeIntoView>
              <div class="img-container justify-content-end">
                <img src="assets/images/capstone-project-img.png" alt="">
              </div>
            </div>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 img-wrapper" appFadeIntoView>
              <div class="img-container justify-content-start">
                <img src="assets/images/mini-projects-img.png" alt="">
              </div>
            </div>
            <div class="col-md-6 col-12 text-wrapper">
              <p class="title" appFadeIntoView>Mini-Projects</p>
              <p class="desc" appFadeIntoView>
                You will build several mini-projects help you apply what you have learned throughout the Bootcamp. One of these is
                accumulative so you can keep building up your skills as you progress through the modules.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="you-will-section you-will-get-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h3 class="section-title" appFadeIntoView>You Will Get</h3>
        </div>
        <div class="col-12 content-wrapper">
          <div class="content-label" appFadeIntoView>
            <span>2 Career Weeks</span>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 text-wrapper">
              <p class="title" appFadeIntoView>Career Services</p>
              <p class="desc" appFadeIntoView>
                Get first-hand industry insight from experts in a variety of sectors. Gain in demand experience from experts. 
                <span class="bold">Get prepared for real-world industry demands.</span>
              </p>
            </div>
            <div class="col-md-6 col-12 img-wrapper" appFadeIntoView>
              <div class="logos-container career">
                <div class="logo-check-item top" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Resume writing</span>
                </div>
                <div class="logo-check-item bottom" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Freelancing Tips</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row content-row">
            <div class="col-md-6 col-12 img-wrapper order-md-0 order-1">
              <div class="logos-container industry" appFadeIntoView>
                <div class="logo" appFadeIntoView>
                  <img src="assets/images/Google.svg" alt="Google">
                </div>
                <div class="logo" appFadeIntoView>
                  <img src="assets/images/Facebook.svg" alt="Facebook">
                </div>
                <div class="logo" appFadeIntoView>
                  <img src="assets/images/Microsoft.svg" alt="Microsoft">
                </div>
                <div class="logo" appFadeIntoView>
                  <img src="assets/images/Spotify.svg" alt="Spotify">
                </div>
              </div>
            </div>
            <div class="col-md-6 col-12 text-wrapper order-md-1 order-0">
              <p class="title" appFadeIntoView>Industry Speakers</p>
              <p class="desc" appFadeIntoView>
                Our industry speakers come from <span class="bold">top-tier corporates</span>. 
                You will be linked to them via a live virtual meeting. They will share their knowledge 
                as well as <span class="bold">current industry trends</span> and demands.
              </p>
              <div class="list">
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">How to get a business license</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Market yourself</span>
                </div>
                <div class="list-item" appFadeIntoView>
                  <img src="assets/images/check-circle-green.svg" alt="" class="icon">
                  <span class="text">Sales & Marketing tips</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="newsletter-section">
    <div class="shadow-bg"></div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title" appFadeIntoView>Our Commitment Does Not End With Graduation</h2>
        </div>
        <div class="col-md-6 col-12">
          <div class="details">
            <h3 class="title" appFadeIntoView>Lifetime access to our newsletter</h3>
            <p class="desc" appFadeIntoView>
              Post-graduation, you receive emails from RoboGarden featuring a variety of available, full-time positions and paid
              freelance projects you can apply for.
            </p>
            <div class="benefit-cards">
              <div class="benefit-card" appFadeIntoView>
                <div class="icon">
                  <img src="assets/images/dollar.svg" alt="">
                </div>
                <span class="text">Job recommendations</span>
              </div>
              <div class="benefit-card" appFadeIntoView>
                <div class="icon">
                  <img src="assets/images/check.svg" alt="">
                </div>
                <span class="text">Develop your talents</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="img-container" appFadeIntoView>
            <img src="assets/images/newsletter-img.svg" alt="">
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="curriculum-section">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-12 order-lg-0 order-1">
          <h2 class="section-title" appFadeIntoView>Curriculum</h2>
          <div class="curriculum-list">
            <div class="module-item" *ngFor="let module of artworksModules" appFadeIntoView>
              <span class="name" [ngClass]="{'active': selectedArtwork?.id === module.id}" (click)="selectedArtwork = module">
                Module {{ module.id }}: {{ module.name }}
              </span>
            </div>
            <div class="button-row">
              <button type="button" class="btn btn-primary plan-btn" appFadeIntoView>
                <span class="btn-label">Download Syllabus</span>
                <i class="pi pi-arrow-right"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12 order-lg-1 order-0">
          <div class="artwork-container">
            <div class="artwork me-lg-0 mx-auto" appFadeIntoView>
              <app-landing-artworks [selectedArtwork]="selectedArtwork" *ngIf="selectedArtwork"></app-landing-artworks>
              <!-- <div class="img-artwork" *ngIf="selectedArtwork?.id !== 1">
                <img [src]="selectedArtwork?.img" alt="">
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="staff-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title" appFadeIntoView>Meet Your Teaching Staff</h2>
        </div>
        <div class="col-12">
          <div class="staff-card staff-card-start" appFadeIntoView>
            <div class="shadow-bg"></div>
            <div class="img-container">
              <img src="assets/images/staff-sina.png" alt="">
            </div>
            <div class="details">
              <p class="name">Dr. Sina Taghavikish</p>
              <p class="desc">
                Sina Sina is a professional engineer with a PhD in geometrics from the University of Calgary. He has more than 15 years'
                experience in mapping, geomatics and civil engineering. He uses Python to develop an industrial IoT solution for
                monitoring strain gauges and metric cameras in Calgary's municipal building's trusses upgrades.
              </p>
            </div>
          </div>
          <div class="staff-card staff-card-end" appFadeIntoView>
            <div class="shadow-bg"></div>
            <div class="details">
              <p class="name">Nicole Woodland</p>
              <p class="desc">
                Nicole has been a machine learning and artificial intelligence instructor at RoboGarden since 2019. She supports
                balanced development in the energy industry using data analysis, visualizations, and data storytelling. In addition to
                teaching, she provides consulting services for advanced data analysis and machine learning.
              </p>
            </div>
            <div class="img-container">
              <img src="assets/images/staff-nicole.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="students-section">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title" appFadeIntoView>Hear it from our students</h2>
        </div>
        <div class="col-12 row mx-0 student-cards-row">
          <swiper
            [config]="config"
            (swiper)="onSwiper($event)"
            (slideChange)="onSlideChange()"
          >
            <ng-template ngFor let-student [ngForOf]="students">
              <ng-template swiperSlide>
                <div class="student-card" appFadeIntoView>
                  <div class="shadow-bg"></div>
                  <img [src]="student.bg" class="net-bg" [ngClass]="student.class ? student.class : ''" alt="">
                  <div class="student-card-top">
                    <div class="student-img">
                      <img [src]="student.img" alt="">
                    </div>
                  </div>
                  <div class="student-card-body">
                    <p class="student-testimonial">{{ student.testimonial }}</p>
                    <p class="student-name">{{ student.name }}</p>
                  </div>
                </div>
              </ng-template>
            </ng-template>
          </swiper>
        </div>
      </div>
    </div>
  </section>
  <section class="partners-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h2 class="section-title" appFadeIntoView>Recognized and trusted by</h2>
        </div>
        <div class="col-12">
          <div class="logos-container">
            <a *ngFor="let logo of logos" [href]="logo.link" target="_blank" class="logo" appFadeIntoView>
              <img [src]="logo.img" alt="">
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="contact-us-section">
    <img src="assets/images/contact-circles-bg.png" alt="" class="bg-img top">
    <img src="assets/images/contact-girl-bg.png" alt="" class="bg-img bottom">
    <div class="shadow-bg"></div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="form-card">
            <h4 class="card-title" appFadeIntoView>Haven't made up your mind yet?</h4>
            <p class="card-subtitle" appFadeIntoView>Our Advisors are here to answer your questions.</p>
            <form class="contact-us-form">
              <h6 class="form-title" appFadeIntoView>Fill the form and one of our advisors will reach you out</h6>
              <div class="form-controls-container">
                <div class="form-group" appFadeIntoView>
                  <label for="fullname" class="form-group-label">Full name</label>
                  <input type="text" id="fullname" class="form-control" placeholder="Full name">
                </div>
                <div class="form-group" appFadeIntoView>
                  <label for="email" class="form-group-label">Email Adress</label>
                  <input type="email" id="email" class="form-control" placeholder="Enter your email">
                </div>
                <div class="form-group" appFadeIntoView>
                  <label for="phone" class="form-group-label">Phone Number</label>
                  <input type="text" id="phone" class="form-control" placeholder="Phone number">
                </div>
              </div>
              <button type="button" class="btn btn-secondary" appFadeIntoView>
                <span class="btn-label">Submit Form</span>
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>